import { employmentTypes } from "../../../constants";
import criteria from "../../../utils/criteria";

const { SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL } = employmentTypes;

const {
  loanAmountBetween,
  creditScoreGreaterThan,
  employmentType,
  timeOfEmploymentGreaterThan,
  creditScoreBetween,
  termIsBetween
} = criteria;

const base = [
  {
    name: "Tier 1",
    rate: 9.49,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreGreaterThan(1050)],
  },
  {
    name: "Tier 2",
    rate: 10.74,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(980, 1049)],
  },
  {
    name: "Tier 3",
    rate: 11.99,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(910, 979)],
  },
  {
    name: "Tier 4",
    rate: 13.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(860, 909)],
  },
  {
    name: "Tier 5",
    rate: 14.49,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(810, 859)],
  },
  {
    name: "Tier 6",
    rate: 15.49,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(790, 809)],
  },
  {
    name: "Tier 7",
    rate: 16.37,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(770, 789)],
  },
  {
    name: "Tier 8",
    rate: 17.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(755, 769)],
  },
  {
    name: "Tier 9",
    rate: 18.12,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(740, 754)],
  },
  {
    name: "Tier 10",
    rate: 18.99,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(725, 739)],
  },
  {
    name: "Tier 11",
    rate: 19.49,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(715, 724)],
  },
  {
    name: "Tier 12",
    rate: 20.43,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(700, 714)],
  },
  {
    name: "Tier 13",
    rate: 21.37,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(680, 699)],
  },
  {
    name: "Tier 14",
    rate: 22.30,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(655, 679)],
  },
  {
    name: "Tier 15",
    rate: 23.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(630, 654)],
  },
  {
    name: "Tier 16",
    rate: 24.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(610, 629)],
  },
  {
    name: "Tier 17",
    rate: 25.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(595, 609)],
  },
  {
    name: "Tier 18",
    rate: 26.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(580, 594)],
  },
  {
    name: "Tier 19",
    rate: 27.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(557, 579)],
  },
  {
    name: "Tier 20",
    rate: 28.24,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(530, 556)],
  },
  {
    name: "Tier 21",
    rate: 28.99,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(505, 529)],
  },
  {
    name: "Tier 22",
    rate: 28.99,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(480, 504)],
  },
  {
    name: "Tier 23",
    rate: 28.99,
    productType: "Standard",
    criteria: [loanAmountBetween(5000, 200000), creditScoreBetween(475, 479)],
  },
];

const employed = base.map((product) => ({
  ...product,
  criteria: [...product.criteria, 
    employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CASUAL,CONTRACT]), 
    timeOfEmploymentGreaterThan(0),
    termIsBetween(24, 84)
  ],
}));

export default {
  date: "27 Feb 2024",
  lender: "Latitude",
  type: "personal",
  logoURL: "https://assets.financeable.com.au/lender-logos/Latitude_Financial_Services_Logo.png",
  actions: [],
  lenderCredentials: [
    {
      label: "Email",
      attribute: "email",
    },
    {
      label: "User Name",
      attribute: "username",
    },
    {
      label: "Password",
      attribute: "password",
    },
    {
      label: "Merchant ID",
      attribute: "organisationId",
    },
    {
      label: "User ID",
      attribute: "brokerId",
    },
    {
      label: "Api Key",
      attribute: "apiKey",
    },
  ],
  requiredFields: {
    asset: ["assetType", "typeOfSale", "ageOfAsset", "glassesMake", "glassesModel", "glassesVariant", "assetValue"],
    customer: [
      "firstName",
      "lastName",
      "dateOfBirth",
      "phoneNumbers?.slice(-1)[0].number",
      "emails?.slice(-1)[0].address",
      //   "addresses[0].street",
      "addresses[0].city",
      "addresses[0].state",
      "addresses[0].postCode",
      "IDNumber",
      "IDCardNumber",
      "addresses[0].monthsAt",
      "addresses[0].yearsAt",
      "employers[0].entityName",
      "employers[0].timeOfEmployment",
      "employers[0].employmentType",
    ],
    agreement: ["introducerDeclarationAgree"],
  },
  fees: [
    {
      name: "Establishment fee",
      value: 395,
      capitalised: true,
      frequency: "upfront",
    },
    {
      name: "Origination fee",
      value: 990,
      capitalised: true,
      frequency: "upfront",
      criteria: [loanAmountBetween(5000, 19999.99)],
    },
    {
      name: "Origination fee",
      value: 1650,
      capitalised: true,
      frequency: "upfront",
      criteria: [loanAmountBetween(20000, 49999.99)],
    },
    {
      name: "Origination fee",
      value: 2500,
      capitalised: true,
      frequency: "upfront",
      criteria: [loanAmountBetween(50000, 200000)],
    },
    {
      name: "Monthly account fee",
      value: 13,
      capitalised: false,
      frequency: "monthly",
    },
  ],
  brokerage: [],
  loading: [],
  info: [
    `Employment: Permanenet Full time/Permanent Part time/Casual: NO minimum time in emplyment, however for new employees <60 days, Employment contract + payslip required.`,
    `Verificatiion of Income: One of Bank Statements (90 days) or Payslip (2 months)`,
    `Contractors/SE - Require an addition to the above - Notice of assessment/individual Tax returns.`,
    `Workers Compensation - Letter from insurer.`
  ],
  productTiers: [...employed],
};
